import { RateDetails } from 'types/domain/RateDetails'

export const parseCancellationDeadlineOffsetObjectToString = (cancellationDeadlineOffset: RateDetails['cancellation_deadline_offset']) =>
  cancellationDeadlineOffset
    ? `${cancellationDeadlineOffset.unit_multiplier} ${cancellationDeadlineOffset.time_unit} ${cancellationDeadlineOffset.drop_time}`
    : undefined
